// Kolejność raportów ośrodka: numer wizyty z nazwy ("IMV 10"), od najwyższego; przy tym samym numerze
// (np. SIV 1 i COV 1) najnowszy pierwszy. Numer z nazwy jest właściwy (decyzja 03.11), VisitNumber tylko gdy nazwa go nie ma.
type Numbered = { name?: string | null; visitNumber?: number | null; created?: Date | string | null };

export const visitNumberOf = (r: Numbered): number | null => {
  const m = r.name?.trim().match(/\s(\d+)$/);
  if (m) return Number(m[1]);
  return r.visitNumber ?? null;
};

export const byVisitNumberDesc = (a: Numbered, b: Numbered): number => {
  const na = visitNumberOf(a), nb = visitNumberOf(b);
  if (na !== nb) {
    if (na == null) return 1; // bez numeru na końcu
    if (nb == null) return -1;
    return nb - na;
  }
  return new Date(b.created ?? 0).getTime() - new Date(a.created ?? 0).getTime();
};
